import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ConversionIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 20"
    >
      <path
        d="M2.55739 10.5668C2.86948 10.5668 3.13923 10.3333 3.17714 10.0155C3.50481 7.26093 5.43948 5.05009 7.97406 4.26709V5.33043C7.97406 5.51634 8.07331 5.68851 8.23448 5.78168C8.39564 5.87443 8.59414 5.87484 8.75531 5.78126L11.9271 3.94943C12.0883 3.85668 12.1876 3.68451 12.1876 3.49859C12.1876 3.31268 12.0883 3.14051 11.9271 3.04776L8.75531 1.21593C8.59414 1.12234 8.39564 1.12276 8.23448 1.21551C8.07331 1.30868 7.97406 1.48084 7.97406 1.66676V2.97126C4.79873 3.78976 2.33906 6.47968 1.93606 9.86826C1.89539 10.2108 2.13989 10.5218 2.48289 10.5624C2.50773 10.5657 2.53256 10.5668 2.55739 10.5668Z"
        fill={color}
      />
      <path
        d="M12.7008 17.1525C10.1512 18.2472 7.26905 17.6758 5.32414 15.8723L6.24697 15.3396C6.40797 15.2466 6.50747 15.0746 6.50755 14.8884C6.5073 14.7025 6.40839 14.5303 6.2468 14.4376L3.07447 12.6067C2.91355 12.5135 2.71489 12.5136 2.5538 12.6066C2.3928 12.6996 2.29339 12.8716 2.29355 13.0575L2.29297 16.7202C2.29255 16.9066 2.39214 17.0783 2.55305 17.1715C2.7143 17.2645 2.91305 17.2644 3.07405 17.1714L4.20297 16.5196C5.73897 18.0855 7.83714 18.9591 10.0002 18.9591C11.0708 18.9591 12.1556 18.7467 13.194 18.3015C13.5114 18.1656 13.6578 17.7977 13.522 17.4803C13.3861 17.1629 13.0191 17.0174 12.7008 17.1525Z"
        fill={color}
      />
      <path
        d="M18.9519 13.6623L17.8235 13.0108C18.702 9.85167 17.6025 6.37667 14.87 4.33425C14.5925 4.12633 14.2019 4.18325 13.9952 4.46042C13.7885 4.73708 13.8446 5.12858 14.1214 5.33525C16.3426 6.99583 17.2899 9.77633 16.7013 12.3629L15.7791 11.8305C15.6181 11.7375 15.4194 11.7375 15.2581 11.8304C15.0972 11.9236 14.9976 12.0953 14.998 12.2817L14.9986 15.9445C14.9985 16.1304 15.0978 16.3025 15.2589 16.3954C15.4199 16.4884 15.6185 16.4884 15.7795 16.3953L18.9519 14.5644C19.1135 14.4717 19.2124 14.2995 19.2126 14.1136C19.2125 13.9275 19.1129 13.7553 18.9519 13.6623Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ConversionIcon.displayName = 'ConversionIcon';
